import * as yup from 'yup';
import { pick } from 'lodash/fp';
import { validateSwedishOrganizationNumber } from '../../../../../../../utils/validation';

export type BasicInfoField = {
  [key in keyof typeof BasicInfoFieldName]: unknown;
};

export const BasicInfoFieldName = {
  name: 'name',
  number: 'number',
  address: 'address',
  postalCode: 'postalCode',
  city: 'city',
  businessDescription: 'businessDescription',

  shareCapital: 'shareCapital',
  numberShares: 'numberShares',
  lowestCapital: 'lowestShareCapital',
  highestCapital: 'highestShareCapital',
  lowestNumberShares: 'lowestNumberShares',
  highestNumberShares: 'highestNumberShares',
};

export const BasicInfoFieldLabel = {
  name: 'Title',
  number: 'Org. nummer',
  address: 'Bolagets utdelningsadress',
  postalCode: 'Bolagets postnummer',
  city: 'Bolagets postort',
  businessDescription: 'Verksamhetsbeskrivning',

  shareCapital: 'Aktiekapital',
  lowestCapital: 'Aktiekapital (lägst)',
  highestCapital: 'Aktiekapital (högst)',

  numberShares: 'Antal aktier',
  lowestNumberShares: 'Antal aktier (lägst)',
  highestNumberShares: 'Antal aktier (högst)',
};

export const basicInfoValidationSchema = yup.object().shape({
  [BasicInfoFieldName.name]: yup.string().required('Företagsnamn krävs'),
  [BasicInfoFieldName.number]: validateSwedishOrganizationNumber,
});

export const pickCompany = pick([
  BasicInfoFieldName.name,
  BasicInfoFieldName.number,
  BasicInfoFieldName.address,
  BasicInfoFieldName.postalCode,
  BasicInfoFieldName.city,
  BasicInfoFieldName.businessDescription,

  'lowestShareCapital',
  'highestShareCapital',
  'lowestNumberShares',
  'highestNumberShares',
]);

export const pickMetadata = pick(['shareCapital', 'numberShares']);
